export enum SectionName {
  L1Nav = 'L1 Nav',
  L2Nav = 'L2 Nav',
  L3Nav = 'L3 Nav',
  Footer = 'Footer',
  HeroCarousel = 'Hero',
  PromotionBanner = 'Promotion Banner',
  TopSellers = 'Top Sellers',
  EditorialSection = 'Editorial Section',
  Latest = 'Latest',
  Hero = 'Hero',
  Directory = 'Directory',
  ProductDetails = 'Product Details',
  Banner = 'Banner',
  ProductList = 'Product List',
  Recommendation = 'Recommendation',
  Shipping = 'Shipping',
  Payment = 'Payment',
  PaymentConfirmation = 'Payment Confirmation',
  OrderReview = 'Order Review',
  OrderDetails = 'Order details',
  Navigation = 'Navigation',
  Page = 'Page',
  HelpfulLinks = 'Helpful links',
  RelatedLinks = 'Related Links',
  CategoryTile = 'Category Tile',
  AppleCategory = 'Category Apple',
  Accessories = 'Accessories',

  //seems should be in screen name array but according to customer docs it  is here
  RecentlyViewed = 'Recently Viewed',
}

export enum PageName {
  // this 3 itenms are not present in customer documentation but added to support common sense
  RecentlyViewed = 'Recently Viewed',
  MostPopular = 'Most Popular',
  RecentlyAdded = 'Recently Added',

  AnyPage = 'AnyPage',
  Home = 'Home',
  CategoryPage = 'Category Page',
  AppleCategoryPage = 'Category Apple Page',
  BrandPage = 'Brand Page',
  ProductPage = 'Product Page',
  Cart = 'Cart',
  Checkout = 'Checkout',
  Confirmation = 'Confirmation',
  WishList = 'Wish list',
  AccountInfo = 'Account Info',
  OrderHistory = 'Order History',
  BrandDirectory = 'Brand Directory',
  FindAnswers = 'Find answers',
  ShippingAndDelivery = 'Shipping and Delivery',
  ReturnsAndRefunds = 'Returns and Refunds',
  StoreAndProductPolicy = 'Store and Product Policy',
  SearchResults = 'Search Results',
  Sale = 'Sale',
  NotFound = 'Not found',
  NotAvailable = 'Not available',
  MissingInformation = 'Missing Information',
  Logout = 'Logout',
  CheckoutConfirmation = 'Checkout confirmation',
  CheckoutDecline = 'Checkout decline',
}
export type BehavioralTrackingEventType =
  | 'click'
  | 'hover'
  | 'formInteraction'
  | 'focus'
  | 'pageLoad'
  | 'modal'
  | 'communication';

export interface BaseEvent {
  eventType: BehavioralTrackingEventType;
  screenName: PageName | string | null;
  previousScreenName: PageName | string | null;
  previousUrl?: string;
  component: SectionName | null;
  item: string;
  timestamp?: string;

  isFormInteraction?: boolean; //some clicks customer want to register as form interactions, this prop is intened to be used to mark that cases
  isExternal?: boolean; // to mark event as one that have link leading user outside of website
  externalLink?: string; // when isExternal: true it holds url of external link
  _ignore?: boolean; //sometimes you dont want to track event because of some external conditions, prop for that
}

export interface PageLoadEvent
  extends Pick<BaseEvent, 'screenName'>,
    Pick<BaseEvent, 'previousScreenName'>,
    Pick<BaseEvent, 'previousUrl'> {
  productId?: string;
  brandId?: string;
  categoryId?: string;
}

export interface EventProductInCart extends BaseEvent {
  brand: string;
  productName: string;
  productDetails: string;
  isPromo?: boolean;
}

export interface EventNavigationMenu extends BaseEvent {
  position: string;
}

export interface EventFormInteractRequest extends BaseEvent {
  formName: string;
  fieldName: string;
  value: string;
  _isIncludeValue: boolean;
  position: number;
}

export interface EventHeroCarousel extends BaseEvent {
  position: number;
}

export interface EventCardsSliderNavigation extends EventHeroCarousel {
  direction: 'right' | 'left';
}

export interface EventOrderListRowAction extends BaseEvent {
  item: 'collapse' | 'expand';
  order: string;
  orderStatus: string;
}

export interface EventCommunicationError
  extends Pick<BaseEvent, 'eventType'>,
    Partial<Pick<BaseEvent, 'screenName' | 'timestamp'>> {
  cms: string;
  csr: string;
}
